import React from "react";
import { Table, Spinner, Alert } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useCrHistory } from "./useContractReviewApi";

/**
 * Historical tab — lists other CRs for the same customer (Pass 1 §1.5 + §1.10).
 * Double-click opens that CR (the route resolves whether the user is viewer or author).
 * Optional SSW Part filter — when current CR has a "SSW Part No." Key response, we pass it.
 */
export default function HistoricalTab({ custId, currentCrId, sswPart }) {
    const navigate = useNavigate();
    const { data, isLoading, error } = useCrHistory(custId, currentCrId, sswPart, !!custId);

    if (!custId) {
        return <div className="text-muted py-3">Pick a customer to see prior Contract Reviews.</div>;
    }
    if (isLoading) {
        return <div className="text-center py-3"><Spinner size="sm" /></div>;
    }
    if (error) {
        return <Alert color="danger">Could not load history.</Alert>;
    }

    return (
        <Table size="sm" bordered responsive className="align-middle">
            <thead className="table-light">
                <tr>
                    <th style={{ width: "8%" }}>CR #</th>
                    <th style={{ width: "26%" }}>Title</th>
                    <th style={{ width: "14%" }}>SSW Part</th>
                    <th style={{ width: "10%" }}>Sales Rep</th>
                    <th style={{ width: "9%" }}>SO #</th>
                    <th style={{ width: "9%" }}>Quote #</th>
                    <th style={{ width: "12%" }}>Type</th>
                    <th style={{ width: "12%" }}>Disposition</th>
                </tr>
            </thead>
            <tbody>
                {(data || []).map((row) => (
                    <tr
                        key={row.crNumber}
                        onDoubleClick={() => navigate(`/contract-review/${row.crNumber}`)}
                        style={{ cursor: "pointer" }}
                    >
                        <td>
                            <button type="button" className="btn btn-link p-0 text-decoration-none"
                                onClick={() => navigate(`/contract-review/${row.crNumber}`)}>
                                {row.crNumber}
                            </button>
                        </td>
                        <td>{row.title}</td>
                        <td>{row.sswPart}</td>
                        <td>{row.salesRep}</td>
                        <td>{row.salesOrderNum || ""}</td>
                        <td>{row.quoteNumber || ""}</td>
                        <td>{row.developmental ? "Developmental" : row.semiDevelopmental ? "Semi-Dev" : ""}</td>
                        <td>{row.disposition || ""}</td>
                    </tr>
                ))}
                {(data || []).length === 0 && (
                    <tr><td colSpan={8} className="text-center text-muted py-3">No prior CRs for this customer.</td></tr>
                )}
            </tbody>
        </Table>
    );
}
